module.exports = __webpack_public_path__ + "static/media/canada.b347bb2f.png";